module.exports = __webpack_public_path__ + "static/media/icon5.77b20ca4.png";